<template>
  <div class="Center">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "center"
};
</script>
<style lang="scss" scoped>
.Center {
  height: 100%;
  background: #ffffff;
  overflow: auto;
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  
}
</style>